/* ==========================================================
   Luniah — Launch Landing Script
   File: assets/luniah-launch.js
   - Gentle scroll-reveal animations
   - Smooth in-page scrolling for #luniah-join
   - Hides the fallback form once Klaviyo mounts its own
   ========================================================== */
(function () {
  'use strict';

  // 1) Reveal on scroll
  var revealEls = document.querySelectorAll('.luniah-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // 2) Smooth scroll for in-page CTAs
  document.querySelectorAll('a[href="#luniah-join"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById('luniah-join');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var input = target.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 400);
    });
  });

  // 3) Hide the fallback form once Klaviyo successfully mounts
  //    Klaviyo injects an <iframe> or <form> inside .klaviyo-form-XXXXXX.
  var klaviyoHost = document.querySelector('[class^="klaviyo-form-"]');
  var fallback   = document.querySelector('[data-luniah-fallback]');
  if (klaviyoHost && fallback) {
    var check = function () {
      if (klaviyoHost.children.length > 0) {
        fallback.style.display = 'none';
        var fine = fallback.parentNode.querySelector('.luniah__fineprint');
        if (fine) fine.style.display = 'none';
        return true;
      }
      return false;
    };
    if (!check()) {
      var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
      mo.observe(klaviyoHost, { childList: true, subtree: true });
      // Stop watching after 10s if Klaviyo never loads — keep the fallback visible.
      setTimeout(function () { mo.disconnect(); }, 10000);
    }
  }
})();
